// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ActivateView_Wrapper__1ycDD","Activate":"ActivateView_Activate__OfUlF","Logo":"ActivateView_Logo__u-7r6","Error":"ActivateView_Error__2xqxU"};